import React from "react";
import styles from "./SubscriptionLicense.module.css";
import Button from "../../../../common-ui-components/components/button/Button";
import {useNavigate} from 'react-router-dom';

function SubscriptionLicense({subscriptionData}) {
    const navigate =useNavigate();

    if (!subscriptionData) return null;

    const {
        editionName,
        purchasedEndpoint,
        enrolledEndpoint,
        purchasedTechnician,
        enrolledTechnician,
        billingCycle,
        nextRenewal,
        subscriptionId,
        contactEmail,
        cancelled=false,
    } = subscriptionData;

    const manageBtn=()=>{
        if(cancelled===true)
        {
            navigate("/app/settings/account/subscription/")
        }
        else
        {
            navigate("/app/settings/account/subscription/manage")
        }
    }

    return (
        <div className={styles.container}>
            <p className={styles.heading}>License Summary</p>
            <main className={styles.main}>
                <div className={styles.title}>
                    <div className={styles.editionNameWrapper}>
                        <p className={styles.editionNameWrapper}>
                            {editionName}
                        </p>
                    </div>
                    <div className={styles.renewal}>
                        {billingCycle} <span className={styles.divident}>|</span> Renews at {nextRenewal}{cancelled && <span className={styles.cancelled}>Cancelled</span>}
                    </div>
                    <div className={styles.manage}>
                        <Button onClick={manageBtn} children={"Manage"} variant={"primary"}/>
                    </div>
                </div>
                {/*user details div*/}
                <div className={styles.userDetails}>
                    <div className={styles.data}>
                        <Details name={"Subscription ID"} value={subscriptionId} />
                        <Details name={"Contact Email/Phone for Billing"} value={contactEmail} />
                    </div>
                    <div className={styles.data2}>
                        <Details name={"Endpoints"} value={`${purchasedEndpoint} (purchased) /${enrolledEndpoint} (enrolled)`} />
                        {purchasedTechnician>0 && <Details name={"Additional Technicians"} value={`${purchasedTechnician} (purchased)  /${enrolledTechnician} (assigned)`} />}
                        {purchasedTechnician===0 && <Details name={"Additional Technicians"} value={`${enrolledTechnician}`} />}
                    </div>
                    {/*<DividedInfo data={subscriptionData} />*/}
                </div>
            </main>
        </div>
    );
}
const Details=({name,value})=>{
    return(
        <div className={styles.detail}>
            <p className={styles.name}>{name}</p>
            <p className={styles.value}>{value}</p>
        </div>
    )
}

export default SubscriptionLicense;